import { render, staticRenderFns } from "./ModalTaskDescription.vue?vue&type=template&id=5d774a51&scoped=true"
import script from "./ModalTaskDescription.vue?vue&type=script&lang=js"
export * from "./ModalTaskDescription.vue?vue&type=script&lang=js"
import style0 from "./ModalTaskDescription.vue?vue&type=style&index=0&id=5d774a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d774a51",
  null
  
)

export default component.exports